import { FilterMenu } from '@/components/FilterMenu'
import { useApiaries } from '@/contexts/useApiaries'
import type { DeploymentLabelOption } from '@/contexts/useApiaries'
import { useTranslation } from 'react-i18next'

interface DeploymentLabelFilterProps {
  selectedOption: DeploymentLabelOption | null
  onChange: (option: DeploymentLabelOption | null) => void
}

export function DeploymentLabelFilter({
  selectedOption,
  onChange,
}: DeploymentLabelFilterProps) {
  const { t } = useTranslation()
  const { deploymentLabels } = useApiaries()

  return (
    <FilterMenu
      buttonLabel={t('clusterConfigTable.filters.deploymentLabel')}
      options={deploymentLabels}
      selectedOption={selectedOption}
      onOptionChange={onChange}
      isSearchable
      data-testid="deployment-label-filter"
    />
  )
}
